// Map API errors to friendly, user-facing copy. The api client's req() throws
// `Error("<status> <errorCode>")` (e.g. "402 upgrade_required"), so we match
// on the known codes/statuses and fall back to a supplied generic message —
// never leaking the raw "402 upgrade_required" string to a user.

const MAP: Array<[test: RegExp, message: string]> = [
  [/upgrade_required/, "Your trial has ended — subscribe from workspace settings to keep going."],
  [/turnstile_failed/, "Please complete the verification challenge and try again."],
  [/rate_limited|\b429\b/, "Too many attempts — please wait a moment and try again."],
  [/email_unverified/, "Please confirm your email address first."],
  [/\bforbidden\b|\b403\b/, "You don't have access to do that."],
  [/unauthorized|\b401\b/, "Your session expired — please sign in again."],
  [/not_found|\b404\b/, "That item no longer exists."],
  [/\b5\d\d\b|internal_error/, "Something went wrong on our end. Please try again."],
];

export function friendlyError(e: unknown, fallback = "Something went wrong. Please try again."): string {
  const raw = String((e as Error)?.message ?? e ?? "");
  for (const [test, message] of MAP) {
    if (test.test(raw)) return message;
  }
  // If the server sent a human `message` field, req() only kept the code — so
  // there's nothing friendlier to show than the fallback.
  return fallback;
}
